import { Box } from "@material-ui/core";
import { useState } from "react";
import { TaskStatus } from "../../../../models/generated/graphql";
import InboxTaskContent, { InboxTaskContentPayload } from "./InboxTaskContent";

export interface InboxTaskProps {
	taskId: string;
	taskDate: number | string;
	triggerEventId: number;
	taskStatus: TaskStatus | null;
	isAssignee: boolean;
	isCompleted: boolean;
	content: InboxTaskContentPayload;
	index: number;
}

const rowStyle = (index: number, isHovering: boolean) => {
	if (!isHovering && index % 2 === 0) return { backgroundColor: "#fff" };

	if (isHovering) return { backgroundColor: "rgba(126, 166, 180, 0.15)" };

	return { backgroundColor: "rgba(126, 166, 180, 0.08)" };
};

const InboxTask: React.FC<InboxTaskProps> = (props: InboxTaskProps) => {
	const [show, setShow] = useState(false);

	return (
		<Box
			style={rowStyle(props.index, show)}
			onMouseEnter={() => {
				setShow(true);
			}}
			onMouseLeave={() => {
				setShow(false);
			}}
		>
			<InboxTaskContent isVisible={show} {...props} />
		</Box>
	);
};

export default InboxTask;
